import { CertifyData, UncertifyData } from 'api/data-certifications-endpoint';
import Button from '@mui/material/Button';
import { DataCertification } from 'types/data-certification';
import { canCertifyData } from 'utilities/AuthService';

interface DataCertificationButtonProps {
  onError: (message: string) => void;
  setLoading: (b: boolean) => void;
  onSuccess: () => void;
  dataCertification: DataCertification | undefined;
  districtId?: string;
  schoolId?: string;
}

export default function DataCertificationButton({ onError, dataCertification, setLoading, onSuccess, districtId, schoolId }: DataCertificationButtonProps): JSX.Element {
  const currentUserCanCertifyData = canCertifyData();

  if (!currentUserCanCertifyData) {
    return <></>;
  }

  const handleClick = async () => {
    setLoading(true);

    let queryParams = '';
    if (districtId) {
      queryParams += `districtId=${districtId}&`;
    }
    if (schoolId) {
      queryParams += `schoolId=${schoolId}`;
    }

    if (dataCertification && dataCertification.IsCertified) {
      const response = await UncertifyData(queryParams);
      if (response.success) {
        onSuccess();
      } else {
        onError(response.message || '');
      }
    } else {
      const response = await CertifyData(queryParams);
      if (response.success) {
        onSuccess();
      } else {
        onError(response.message || '');
      }
    }
    setLoading(false);
  };

  return (
    <Button variant='contained' color='primary' onClick={handleClick} style={{ width: 'fit-content', margin: '10px auto 0px' }}>
      {dataCertification && dataCertification.IsCertified ? 'Mark as uncertified' : 'Certify'}
    </Button>
  );
}
